import React from 'react';
import { getStorage, setStorage } from '@utils/localStorage';
import * as Ids from '@utils/ids';

import Modal from '@roo/roo/Modal';
import * as LX from '@utils/lxWrapper';
import moment from 'moment';
import * as API from '../api';
import {
    CombineOrderNoticeContentStyle,
    CombineOrderNoticeContentType,
    ICombineOrderNotice,
} from '../api/define';

type CacheInfoType = {
    [key: string]: any;
};

type StyleMap = {
    [key in CombineOrderNoticeContentStyle]: React.CSSProperties;
};

// 样式表
const styleMap: StyleMap = {
    [CombineOrderNoticeContentStyle.NORMAL_TEXT]: {},
    [CombineOrderNoticeContentStyle.BOLD_RED_TEXT]: {
        color: '#f76c6c',
        fontSize: '16px',
    },
    [CombineOrderNoticeContentStyle.SMALL_FONTSIZE_TEXT]: {
        fontSize: '10px',
    },
};

/**
 * @private 渲染弹窗内容节点
 * @param description
 * @returns Array<React.ReactNode>
 */
const _renderContent = (description: ICombineOrderNotice['newDescription']) => {
    const nodes: Array<React.ReactNode> = [];

    if (!description || !Array.isArray(description)) {
        return null;
    }

    description.forEach(item => {
        const currNodes = [];
        // 段落内拼接
        if (Array.isArray(item.content)) {
            currNodes.push(
                item.content.map(v => {
                    switch (v.type) {
                        case CombineOrderNoticeContentType.IMAGE:
                            return <img src={v.content} style={{ width: '100%' }} />;
                        case CombineOrderNoticeContentType.TEXT:
                        default:
                            return <span style={styleMap[v.style]}>{v.content}</span>;
                    }
                }),
            );
        }
        // 每个段落
        if (currNodes.length > 0) {
            nodes.push(<div style={{ marginBottom: '17px' }}>{currNodes}</div>);
        }
    });

    return nodes;
};

const phfCombineOrder = () => {
    const CACHE_KEY = 'PHF_COMBINE_ORDER_REMIND';
    const cacheInfoStr = getStorage(CACHE_KEY) || '{}';
    let cacheInfo: CacheInfoType = {};

    try {
        cacheInfo = JSON.parse(cacheInfoStr);
    } catch (e) {
        //
    }

    const wmPoiId = Ids.getWmPoiId();

    if (wmPoiId && wmPoiId !== '-1') {
        const poiInfo = cacheInfo[wmPoiId] || {};
        // 已展示次数
        const cnt: number = poiInfo.cnt || 0;
        // 上次展示的时间
        const lastShowDate = poiInfo.lastShowDate || '';
        const today = moment().format('YYYYMMDD');
        // 判断上次展示时间不是今天
        const isNotToday = lastShowDate !== today;

        // 弹窗最多弹 2 次，且每天只弹 1 次
        if (cnt < 2 && isNotToday) {
            API.combineOrderNoticePHF().then(data => {
                // 是拼好饭门店且没有曾经开启过一起送
                if (
                    data.isPhfPoiGray &&
                    !data.isCombineOrder &&
                    !data.hasOpenedSendTogetherSwitch
                ) {
                    const start = Date.now();
                    // 灰度商家且没有开启拼单
                    Modal.confirm({
                        size: 'lg',
                        title: data.title,
                        onConfirm: () => {
                            const end = Date.now();
                            // https://ocean.sankuai.com/config/#/page/detail?id=42210958&channelId=45&tabName=module
                            LX.reportMC('b_waimai_e_0zz8pae7_mc', 'c_waimai_e_mstno9tm', {
                                duration: end - start,
                            });
                        },
                        children: _renderContent(data.newDescription),
                        showCancelButton: false,
                        closable: false,
                        backdropClosable: false,
                        confirmText: '我知道了',
                    });

                    // https://ocean.sankuai.com/config/#/page/detail?id=42210958&channelId=45&tabName=module
                    LX.reportMV('b_waimai_e_0zz8pae7_mv', 'c_waimai_e_mstno9tm');

                    cacheInfo[wmPoiId] = {
                        cnt: cnt + 1, // 已展示次数
                        lastShowDate: today, // 上次展示日期
                    };
                    setStorage(CACHE_KEY, JSON.stringify(cacheInfo));
                }
            });
        }
    }
};

export default phfCombineOrder;
